import React, { useState } from 'react'

const AddToFav = ({ color = '#fff', hoverColor = '#bbfa33', imgClass = '' }) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={imgClass}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      viewBox="0 0 21.407 18.068"
    >
      <path
        data-name="favorite-svgrepo-com (3)"
        d="M1 7.714C1 3.873 4.056 3 5.8 3c2.184 0 3.93 1.746 4.8 3.056C11.476 4.746 13.223 3 15.405 3c1.746 0 4.8.873 4.8 4.714 0 5.762-9.6 11-9.6 11S1 13.477 1 7.714z"
        transform="translate(.1 -1.9)"
        style={{ fill: 'none', stroke: isHovered ? hoverColor : color, strokeWidth: '2.2px' }}
      />
    </svg>
  )
}

export default AddToFav
